@if (data?.title) {
  <h5 mat-dialog-title>{{data.title}}</h5>
}
<div mat-dialog-content>
  {{data.text}}
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false" cdkFocusInitial class="btn btn-primary mr-auto">{{data.cancelText}}</button>
  <button mat-button [mat-dialog-close]="true" class="btn btn-success ml-auto">{{data.okText}}</button>
</div>